import { Sizes } from '@sede-x/shell-ds-react-base';

import { EmptyStateSize } from './EmptyState.types';

type EmptyStateConstsType = {
  [sizes in EmptyStateSize]: {
    icon: number;
    pictogram: number;
    image: number;
    gap: number;
    textGap: number;
    actionsGap: number;
  };
};

export const emptyStateConsts: EmptyStateConstsType = {
  [Sizes.ExtraSmall]: {
    icon: 32,
    pictogram: 48,
    image: 116,
    gap: 12,
    textGap: 4,
    actionsGap: 12,
  },
  [Sizes.Small]: {
    icon: 40,
    pictogram: 64,
    image: 132,
    gap: 20,
    textGap: 8,
    actionsGap: 12,
  },
  [Sizes.Medium]: {
    icon: 52,
    pictogram: 76,
    image: 164,
    gap: 24,
    textGap: 8,
    actionsGap: 16,
  },
  [Sizes.Large]: {
    icon: 64,
    pictogram: 96,
    image: 200,
    gap: 32,
    textGap: 12,
    actionsGap: 16,
  },
};
